import React, { Fragment } from 'react'
import Slider from 'react-slick'

const settings = {
    dots: false,
    arrows: true,
    infinite: true,
    fade: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
}

/**
 * @param {{
 *   openModal?: () => void;
 *   imageSrc?: string;
 *   imageAlt?: string;
 *   showPlayButton?: boolean;
 * }} props
 */
const VideoSliderOne = (props) => {
    const {
        openModal,
        imageSrc,
        imageAlt = '운영·모니터링 현장',
        showPlayButton = !imageSrc,
    } = props

    if (imageSrc) {
        return (
            <div className="video-slider-one video-slider-one--static">
                <div className="video-wrapper video-wrapper--slot-960x650">
                    <img
                        className="video-wrapper__img"
                        src={imageSrc}
                        alt={imageAlt}
                        loading="lazy"
                        decoding="async"
                    />
                    {showPlayButton && (
                        <a className="popup-video" href="#" onClick={openModal}>
                            <i className="bi bi-play-fill" />
                        </a>
                    )}
                </div>
            </div>
        )
    }

    return (
        <Fragment>
            <Slider {...settings} className="video-slider-one">
                <div className="video-wrapper">
                    <a className="popup-video" href="#" onClick={openModal}>
                        <i className="bi bi-play-fill" />
                    </a>
                </div>
                <div className="video-wrapper">
                    <a className="popup-video" href="#" onClick={openModal}>
                        <i className="bi bi-play-fill" />
                    </a>
                </div>
            </Slider>
        </Fragment>
    )
}

export default VideoSliderOne
